import { get, post, put, remove } from '@/helpers/http';

export function fetchTracks(pagination = {}) {
  return get('/tracks', { ...pagination });
}

export function fetchTracksAnalytics(payload) {
  return get('/analytics/tracks', payload);
}

export function fetchUserTracks(id, pagination = {}) {
  return get(`/tracks/user/${id}`, { ...pagination });
}

export function fetchFollowedTracks(user, pagination = {}) {
  return get('/followed/tracks', { user_id: user.id, ...pagination });
}

export function getDepartmentTracks(departmentId) {
  return get(`/department/tracks/${departmentId}`);
}

export function getTrackById(id) {
  return get(`/tracks/${id}`);
}

export function getTrackFollowStatus(id) {
  return get(`isFollowing/track/${id}`);
}

export function searchTracks(searchTerm, pagination = {}) {
  return post('/search/tracks', { search: searchTerm, ...pagination });
}

export function followTrack(id) {
  return post('follow/track', { track_id: id });
}

export function unfollowTrack(id) {
  return post('unfollow/track', { track_id: id });
}

export function saveNewTrack(track) {
  return post('tracks', track);
}

export function updateTrack(track) {
  return put(`/tracks/${track.id}`, track);
}

export function updateTrackVisits(track) {
  return put(`/track/visit/${track.id}`, track);
}

export function removeTrack(id) {
  return remove(`/tracks/${id}`);
}
